<div class="card-container">
  <div class="unlock">
    <h6 class=" ">{{title}}</h6>
  </div>
  <!--border -->
  <div class="star-img">
    <img src="../../../assets/images/crossfinger.svg" alt="">
  </div>
  <div class="mark-lucky">
    <p>{{description}}</p>
  </div>
  <div class="choose-btn">
    <button (click)="closePopup()">{{closeButton}}</button>
  </div>
</div>